import React from "react";
import { ContainerImagem, Content, ProductRow, QuantityControl } from "../styles";
import { ProductImageAction } from "../ProductImageAction";
import { ProductImage } from "../ProductImage";
import { ProductDetail } from "../ProductDetail";
import { ProductCardActions } from "../ProductCartActions";
import { CheckoutItemsProps } from "../../../../store/modules/checkout/types";

interface IProductView {
    product: CheckoutItemsProps;
}

export function ProductView({ product }: IProductView) {
    return (
        <ProductRow>
            <ContainerImagem>
                <ProductImageAction
                    product={product}>
                    <ProductImage product={product} />
                </ProductImageAction>
            </ContainerImagem>
            <Content>
                <ProductDetail.Root>
                    <ProductDetail.Title title={product.product.short_description || ""} />
                    <ProductDetail.Price price={product.total} product={product.product} quantity={Number(product.quantity)} />
                    <ProductDetail.Warranty productId={product.id} />
                </ProductDetail.Root>
                <ProductCardActions.Root>
                    {/* Container dos botões de quantidade com o valor */}
                    <QuantityControl>
                        <ProductCardActions.Subtraction inputValue={product.quantity} product={product} />
                        <ProductCardActions.value inputValue={product.quantity} un={product.product?.un} />
                        <ProductCardActions.Addtion inputValue={product.quantity} product={product} />
                    </QuantityControl>

                    <ProductCardActions.Observation productId={product.product.product_id} inputValue={product.quantity} ProductObservation={product.additional?.observation} />
                    <ProductCardActions.Delete productId={product.product.product_id} />
                </ProductCardActions.Root>
            </Content>
        </ProductRow>
    );
}